'use client'

import ErrorPage from 'Clutch/Organisms/ErrorPage'

export default function NotFound() {
  return <ErrorPage statusCode={404} hasRecommendations={false} />
}
